module.exports = __webpack_public_path__ + "static/img/pay-en.94c28f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/en/pay-en.png
// module id = UaZd
// module chunks = 0